export default __webpack_public_path__ + "static/media/ic_hungary.82aa9f1c.svg";